export default "__VITE_ASSET__7b3f704a__"